// 02 路由表中后端已上线部分（⊆ backend/internal/app/routes_test.go TestRouteContract；基线 141 行，TD-848 三条包含关系断言锁定）
export type RouteAuth = 'none' | 'bearer' | 'cookie';
export interface RouteDef {
  readonly auth: RouteAuth;
}

const N: RouteDef = { auth: 'none' };
const B: RouteDef = { auth: 'bearer' };
const C: RouteDef = { auth: 'cookie' };

export const ROUTES = {
 'GET /api/admin/crypto-addresses':B,
 'GET /api/admin/crypto-networks':B,
 'GET /api/admin/crypto-income-addresses':B,
 'GET /api/admin/crypto-outgoing-addresses':B,
 'POST /api/admin/crypto-addresses':B,
 'GET /api/admin/crypto-addresses/{id}':B,
 'GET /api/admin/crypto-addresses/{id}/receipts':B,
 'GET /api/admin/crypto-address-summary':B,
 'POST /api/admin/crypto-addresses/{id}/allocation':B,
 'POST /api/admin/crypto-addresses/{id}/balance-refresh':B,
 'POST /api/admin/crypto-addresses/{id}/control-proof':B,
 'POST /api/admin/crypto-addresses/{id}/challenge':B,
 'GET /api/admin/crypto-events':B,
 'GET /api/admin/crypto-exceptions':B,
 'GET /api/admin/crypto-exceptions/{id}':B,
 'POST /api/admin/crypto-exceptions/{id}/actions':B,
 'POST /api/admin/crypto-exception-actions/{id}/approve':B,
 'POST /api/admin/crypto-exception-actions/{id}/reject':B,
 'POST /api/admin/crypto-exception-actions/{id}/cancel':B,
 'GET /api/admin/crypto-refunds':B,
 'POST /api/admin/crypto-remedy-groups':B,
 'GET /api/admin/crypto-remedy-groups/{id}':B,
 'GET /api/admin/crypto-addresses/{id}/monitoring-restore':B,
 'POST /api/admin/crypto-addresses/{id}/monitoring-restore':B,
 'POST /api/admin/crypto-monitoring-restores/{id}/approve':B,
 'POST /api/admin/crypto-monitoring-restores/{id}/reject':B,
 'GET /api/admin/crypto-exceptions/{id}/reorg-hold':B,
 'GET /api/admin/crypto-outflows':B,
 'POST /api/admin/crypto-outflows/{id}/review':B,
 'GET /api/admin/topup-orders':B,
 'POST /api/admin/crypto-evidence-files':B,
 'GET /api/admin/files/crypto-evidence/{id}':B,

  // 公共（11）
  'GET /api/public/config': N,
  'GET /api/public/card-products': N,
  'POST /api/public/register/send-code': N,
  'POST /api/public/register': N,
  'POST /api/public/login': N,
  'POST /api/public/login/telegram': N,
  'POST /api/public/password-reset/send-code': N,
  'POST /api/public/password-reset/verify': N,
  'POST /api/public/password-reset/commit': N,
  'POST /api/public/agent/login': N,
  'POST /api/public/admin/login': N,
  // 用户账号与安全（17）
  'POST /api/user/refresh': C,
  'POST /api/user/logout': B,
  'GET /api/user/devices': B,
  'DELETE /api/user/devices/{id}': B,
  'GET /api/user/profile': B,
  'PUT /api/user/profile': B,
  'PUT /api/user/password': B,
  'POST /api/user/password/set/send-code': B,
  'POST /api/user/password/set': B,
  'POST /api/user/2fa/setup': B,
  'POST /api/user/2fa/enable': B,
  'POST /api/user/2fa/disable': B,
  'POST /api/user/email/send-code': B,
  'POST /api/user/email/confirm': B,
  'POST /api/user/telegram/bind': B,
  'POST /api/user/telegram/unbind': B,
  'POST /api/user/account/merge-email': B,
  // 用户钱包（8）
  'GET /api/user/wallet': B,
  'GET /api/user/wallet/ledger': B,
  /**
   * @deprecated 旧版每人 HD 充值地址已停发（审计 #1 / #26）：只读兼容，仅返回存量地址，无存量 → 1503 reason=legacy_address_retired。
   * 新充值一律走 deposit-networks → deposit-quote → topup-orders（共享收款地址 + 精确金额）；前端不得再调用。
   */
  'GET /api/user/wallet/deposit-address': B,
  /** 批 8a：本人历史专属充值地址只读列表（网络切共享后 deposit-address 不再返回存量地址）；无存量为空列表。 */
  'GET /api/user/wallet/legacy-deposit-addresses': B,
  'GET /api/user/wallet/deposit-networks': B,
  'POST /api/user/wallet/deposit-quote': B,
  'POST /api/user/wallet/topup-orders': B,
  /** 2026-10-15：本人充值订单分页（H5 资产明细「充币」页签）；status ∈ pending|paid|expired|processing，空 = 全部。 */
  'GET /api/user/wallet/topup-orders': B,
  'GET /api/user/wallet/topup-orders/{id}': B,
  /** @deprecated 2026-10-15 H5 已移除「交易哈希自查」入口（入账由 Tatum 回调 + 兜底补扫覆盖），前端不得调用。 */
  'POST /api/user/wallet/topup-orders/{id}/tx-hash': B,
  /** @deprecated 模拟到账仅测试装配显式开启（缺省不注册，主网配置下拒绝启动）；H5 已移除入口，前端不得调用。 */
  'POST /api/user/wallet/deposits/simulate': B,
  'POST /api/user/wallet/withdrawals': B,
  'GET /api/user/wallet/withdrawals': B,
  /** 2026-10-15：提现只读预检（费用 + 收款地址激活判定，与建单同一计算；读链不确定 → activation_check=unknown）。 */
  'GET /api/user/wallet/withdrawals/quote': B,
  'GET /api/user/wallet/fees': B,
  'POST /api/user/wallet/commission/transfer': B,
  // 用户卡（14）
  'GET /api/user/card-products': B,
  'POST /api/user/cards': B,
  'GET /api/user/cards': B,
  'GET /api/user/cards/{id}': B,
  'GET /api/user/cards/{id}/secret': B,
  'POST /api/user/cards/{id}/recharge': B,
  'POST /api/user/cards/{id}/withdraw': B,
  'POST /api/user/cards/{id}/freeze': B,
  'POST /api/user/cards/{id}/unfreeze': B,
  'POST /api/user/cards/{id}/close': B,
  'GET /api/user/cards/{id}/transactions': B,
  'GET /api/user/cards/{id}/sms-codes': B,
  'GET /api/user/transactions': B,
  'GET /api/user/transactions/{id}': B,
  // 用户返佣与通知（4）
  'GET /api/user/referral': B,
  'GET /api/user/referral/commissions': B,
  'GET /api/user/notifications': B,
  'POST /api/user/notifications/read': B,
  // 代理端（23；0045 删 PUT sub-agents/{id}、增售价三条）
  'POST /api/agent/refresh': C,
  'POST /api/agent/logout': B,
  'GET /api/agent/me': B,
  'PUT /api/agent/password': B,
  'GET /api/agent/overview': B,
  'GET /api/agent/prices': B, // 0045 代理加价定价：我的售价
  'PUT /api/agent/prices': B,
  'GET /api/agent/sub-agents/{id}/prices': B, // 直接下级售价（只读）
  'GET /api/agent/fx-rate': B,
  'GET /api/agent/fx-rate/history': B,
  'PUT /api/agent/fx-rate': B,
  'GET /api/agent/links': B,
  'GET /api/agent/sub-agents': B,
  'POST /api/agent/sub-agents': B,
  'POST /api/agent/sub-agents/{id}/reset-password': B,
  'POST /api/agent/sub-agents/{id}/toggle': B,
  'DELETE /api/agent/sub-agents/{id}': B,
  'GET /api/agent/users': B,
  'GET /api/agent/user-transactions': B,
  'GET /api/agent/commissions': B,
  'GET /api/agent/withdrawals': B,
  'POST /api/agent/withdrawals': B,
  /** 2026-10-15：USDT 提佣只读预检（同用户端 withdrawals/quote 结构，network 恒 TRC20）。 */
  'GET /api/agent/withdrawals/quote': B,
  // 后台认证 / 本人 / 参数 / 调账（10）
  'POST /api/admin/refresh': C,
  'POST /api/admin/logout': B,
  'GET /api/admin/me': B,
  'PUT /api/admin/my-password': B,
  'POST /api/admin/2fa/setup': B,
  'POST /api/admin/2fa/confirm': B,
  'POST /api/admin/accounts/{id}/reset-2fa': B,
  'GET /api/admin/settings': B,
  'PUT /api/admin/settings': B,
  'POST /api/admin/users/{id}/adjust': B,
  // 后台卡域与预算（29）
  'GET /api/admin/card-products': B,
  'POST /api/admin/card-products/sync': B,
  'PUT /api/admin/card-products/{id}': B,
  'GET /api/admin/budgets': B,
  'POST /api/admin/budgets/sync': B,
  'POST /api/admin/budgets': B,
  'POST /api/admin/budgets/{id}/topup': B,
  'POST /api/admin/budgets/{id}/withdraw': B,
  'POST /api/admin/budgets/{id}/rebase': B,
  'GET /api/admin/budgets/{id}/ops': B,
  'POST /api/admin/budgets/ops/{biz_no}/resolve': B,
  'GET /api/admin/upstream-costs': B,
  'GET /api/admin/profit/summary': B, // 0047 利润台账汇总（profit.view）
  'GET /api/admin/profit/entries': B, // 0047 利润台账明细（profit.view；format=csv 需 profit.export）
  'GET /api/admin/cards': B,
  'GET /api/admin/cards/{id}': B,
  'POST /api/admin/cards/{id}/recharge': B,
  'POST /api/admin/cards/{id}/withdraw': B,
  'POST /api/admin/cards/{id}/freeze': B,
  'POST /api/admin/cards/{id}/unfreeze': B,
  'POST /api/admin/cards/{id}/close': B,
  'POST /api/admin/cards/{id}/hold': B,
  'POST /api/admin/cards/{id}/release': B,
  'POST /api/admin/cards/{id}/mock-transaction': B,
  'GET /api/admin/cards/{id}/upstream': B, // 上游对照异步补齐（2026-10-15）
  'POST /api/admin/cards/{id}/secret': B, // 2026-10-17 后台卡面明文查看（cardSecret.view + 2FA + 原因；totp 走 body 不进 URL）
  'POST /api/admin/card-transactions/{id}/mock-transition': B, // 对已有交易 Mock 状态流转（仅 dev / sandbox）
  'GET /api/admin/card-actions': B,
  'POST /api/admin/card-actions/{biz_no}/approve': B,
  'POST /api/admin/card-actions/{biz_no}/reject': B,
  'POST /api/admin/card-actions/{biz_no}/reconcile': B,
  'POST /api/admin/card-actions/{biz_no}/resolve': B,
  'GET /api/admin/transactions': B,
  'GET /api/admin/transactions/{id}': B,
  // 后台资金（14）
  'GET /api/admin/reviews': B,
  'POST /api/admin/reviews/deposit/{biz_no}/approve': B,
  'POST /api/admin/reviews/deposit/{biz_no}/reject': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/approve': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/reject': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/mark-paid': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/refund': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/close-overpaid': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/close-overpaid/approve': B,
  'POST /api/admin/reviews/withdrawal/{biz_no}/close-overpaid/reject': B,
  'GET /api/admin/withdrawal-overpayments': B,
  'POST /api/admin/withdrawal-overpayments/{id}/settle': B,
  'GET /api/admin/treasury/sweeps': B,
  // POST /api/admin/treasury/sweeps：2026-10-15 旧功能下线（登记归集），后端不再注册
  // 后台代理与佣金（20；0045 增售价两条）
  'GET /api/admin/agents': B,
  'GET /api/admin/agents/{id}': B,
  'GET /api/admin/agents/{id}/fx-rates': B,
  'GET /api/admin/agents/{id}/tree': B,
  'GET /api/admin/agents/{id}/children': B,
  'GET /api/admin/agents/{id}/prices': B, // 0045 代理售价（agents.view）
  'PUT /api/admin/agents/{id}/prices': B, // 后台代改售价（agents.edit）
  'POST /api/admin/agents': B,
  'PUT /api/admin/agents/{id}': B,
  'POST /api/admin/agents/{id}/reset-password': B,
  'POST /api/admin/agents/{id}/toggle-login': B,
  'DELETE /api/admin/agents/{id}': B,
  'GET /api/admin/agent-users': B,
  'GET /api/admin/commissions': B,
  'GET /api/admin/commissions/negative-beneficiaries': B,
  'POST /api/admin/commissions/{id}/settle': B,
  'POST /api/admin/commissions/settle-all': B,
  'GET /api/admin/agent-withdrawals': B,
  'POST /api/admin/agent-withdrawals/{id}/approve': B,
  'POST /api/admin/agent-withdrawals/{id}/mark-paid': B,
  'POST /api/admin/agent-withdrawals/{id}/reject': B,
  // SP8b 移表锚点（PENDING_SP7 → ROUTES）：各波只在本波锚点下追加本波键，锚点与其间空行保留（TD-848）
  // ---- SP8b W-A 用户与资金（#2–#10）----
  'GET /api/admin/users': B,
  'PUT /api/admin/users/{id}': B,
  'POST /api/admin/users/{id}/ban': B,
  'POST /api/admin/users/{id}/unban': B,
  'GET /api/admin/users/{id}/360': B,
  'GET /api/admin/users/{id}/kyc': B,
  'GET /api/admin/files/kyc/{id}': B,
  'POST /api/admin/users/{id}/kyc-review': B,
  'GET /api/admin/wallet-logs': B,

  // ---- SP8b W-B 运营观测（#1、#35–#43）----
  'GET /api/admin/dashboard': B,
  'GET /api/admin/webhooks': B,
  'POST /api/admin/webhooks/{id}/replay': B,
  'GET /api/admin/tasks': B,
  'POST /api/admin/tasks/{id}/query': B,
  'GET /api/admin/api-calls': B,
  'GET /api/admin/alerts': B,
  'POST /api/admin/alerts/{id}/ack': B,
  'POST /api/admin/alerts/test': B, // 2026-10-20 C-14 ⑦ 发送测试告警（settings.edit）
  'GET /api/admin/operations': B,
  'GET /api/admin/operations/{id}': B,

  // ---- SP8b W-C1 资金出入与上游（#44–#63）----
  'GET /api/admin/upstream/wallet': B, // #44
  'GET /api/admin/upstream/wallet-logs': B, // #45
  'GET /api/admin/upstream/credentials': B, // #46
  'GET /api/admin/upstream/endpoint-health': B, // #47
  'POST /api/admin/upstream/test-webhook': B, // #48
  'GET /api/admin/payouts': B, // #49
  'POST /api/admin/payouts': B, // #50
  'POST /api/admin/payouts/{id}/retry': B, // #51
  'POST /api/admin/payouts/{id}/reconcile': B, // #52
  'GET /api/admin/payout-beneficiaries': B, // #53
  'POST /api/admin/payout-beneficiaries': B, // #54
  'PUT /api/admin/payout-beneficiaries/{id}': B, // #55
  'DELETE /api/admin/payout-beneficiaries/{id}': B, // #56
  'GET /api/admin/payout-quota': B, // #57
  'GET /api/admin/orders': B, // #58
  'POST /api/admin/orders/{id}/refund': B, // #59
  'POST /api/admin/orders/{id}/ship': B, // #60
  'GET /api/admin/order-logistics': B, // #61
  'POST /api/admin/order-logistics/{id}/cancel': B, // #62
  'GET /api/admin/payment-assets': B, // #63

  // ---- SP8b W-C2 平台管理（#11–#34）----
  'GET /api/admin/risk-rules': B,
  'POST /api/admin/risk-rules': B,
  'PUT /api/admin/risk-rules/{id}': B,
  'DELETE /api/admin/risk-rules/{id}': B,
  'GET /api/admin/risk-hits': B,
  'GET /api/admin/contents': B,
  'POST /api/admin/contents': B,
  'GET /api/admin/contents/{id}': B,
  'PUT /api/admin/contents/{id}': B,
  'DELETE /api/admin/contents/{id}': B,
  'POST /api/admin/contents/{id}/reply': B,
  'GET /api/admin/accounts': B,
  'POST /api/admin/accounts': B,
  'PUT /api/admin/accounts/{id}': B,
  'DELETE /api/admin/accounts/{id}': B,
  'POST /api/admin/accounts/{id}/reset-password': B,
  'POST /api/admin/accounts/{id}/toggle': B,
  'GET /api/admin/accounts/{id}/login-logs': B,
  'GET /api/admin/roles': B,
  'POST /api/admin/roles': B,
  'PUT /api/admin/roles/{id}': B,
  'DELETE /api/admin/roles/{id}': B,
  'GET /api/admin/roles/{id}/permissions': B,
  'PUT /api/admin/roles/{id}/permissions': B,

  // ---- SP8b W-E H5 接通（#64–#73）----
  'GET /api/user/kyc': B,
  'POST /api/user/kyc': B,
  'GET /api/user/kyc/files/{id}': B,
  'GET /api/user/notices': B,
  'GET /api/user/faqs': B,
  'GET /api/user/tickets': B,
  'GET /api/user/tickets/{id}': B,
  'POST /api/user/tickets': B,
  'POST /api/user/tickets/{id}/reply': B,
  'POST /api/user/transactions/{id}/dispute': B,

  // ---- SP9 Bot（02 §6.2 L255 / §6.3；后端 httpapi/routes_admin_bots.go）----
  'GET /api/admin/bots': B,
  'GET /api/admin/bots/{id}': B,
  'POST /api/admin/bots': B,
  'PUT /api/admin/bots/{id}': B,
  'DELETE /api/admin/bots/{id}': B,
  'POST /api/admin/bots/{id}/test': B,
  'POST /api/admin/bots/{id}/set-webhook': B,
  'POST /api/admin/bots/{id}/regenerate-secret': B,
  'POST /api/admin/bots/{id}/publish': B,
  'POST /api/admin/bots/{id}/set-primary': B, // 0039 平台主 Bot（C-15 设为主 Bot）

  // ---- 0049 Bot 广告推送（Console C-33 / 代理端群发；后端 httpapi/routes_broadcast.go）----
  'GET /api/admin/broadcasts': B,
  'GET /api/admin/broadcasts/{id}': B,
  'POST /api/admin/broadcasts': B,
  'PUT /api/admin/broadcasts/{id}': B,
  'POST /api/admin/broadcasts/estimate': B,
  'POST /api/admin/broadcast-files': B,
  'GET /api/admin/files/broadcast/{id}': B,
  'POST /api/admin/broadcasts/{id}/preview': B,
  'POST /api/admin/broadcasts/{id}/submit': B,
  'POST /api/admin/broadcasts/{id}/pause': B,
  'POST /api/admin/broadcasts/{id}/resume': B,
  'POST /api/admin/broadcasts/{id}/cancel': B,
  'POST /api/admin/broadcasts/{id}/approve': B,
  'POST /api/admin/broadcasts/{id}/reject': B,
  'GET /api/admin/broadcasts/{id}/runs': B,
  'GET /api/admin/broadcast-runs/{rid}': B,
  'GET /api/admin/broadcast-runs/{rid}/deliveries': B,
  'GET /api/admin/broadcast-runs/{rid}/export': B,
  'GET /api/admin/broadcast-settings': B,
  'PUT /api/admin/broadcast-settings': B,
  'GET /api/admin/broadcast-bots': B,
  'PUT /api/admin/me/telegram-id': B, // 个人设置：绑定 / 解除本人 Telegram ID（预览发送目标）
  'GET /api/agent/broadcasts': B,
  'GET /api/agent/broadcasts/{id}': B,
  'POST /api/agent/broadcasts': B,
  'PUT /api/agent/broadcasts/{id}': B,
  'POST /api/agent/broadcasts/estimate': B,
  'POST /api/agent/broadcast-files': B,
  'GET /api/agent/files/broadcast/{id}': B,
  'POST /api/agent/broadcasts/{id}/preview': B,
  'POST /api/agent/broadcasts/{id}/submit': B,
  'POST /api/agent/broadcasts/{id}/pause': B,
  'POST /api/agent/broadcasts/{id}/resume': B,
  'POST /api/agent/broadcasts/{id}/cancel': B,
  'GET /api/agent/broadcasts/{id}/runs': B,
  'GET /api/agent/broadcast-runs/{rid}': B,
  'GET /api/agent/broadcast-runs/{rid}/deliveries': B,
  'GET /api/agent/broadcast-bots': B,
  'GET /api/agent/broadcast-quota': B,
} as const satisfies Readonly<Record<string, RouteDef>>;

export type RouteKey = keyof typeof ROUTES;
export type Aud = 'user' | 'agent' | 'admin';

export function routeAud(key: string): Aud {
  if (key.endsWith(' /api/public/agent/login')) return 'agent';
  if (key.endsWith(' /api/public/admin/login')) return 'admin';
  const m = / \/api\/(user|agent|admin)\//.exec(key);
  return m && (m[1] === 'agent' || m[1] === 'admin') ? m[1] : 'user';
}

export function splitRoute(key: string): { method: string; path: string } {
  const sp = key.indexOf(' ');
  return { method: key.slice(0, sp), path: key.slice(sp + 1) };
}
